import { Axios, isAxiosError } from "axios";

// Cria uma instância do axios
const axiosInstance = new Axios({
    timeout: 10000,
    transformRequest: [(data) => JSON.stringify(data)],
    transformResponse: [(data) => {
        try {
            return JSON.parse(data);
        } catch (error) {
            return data;
        }
    }],
    headers: {
        'Content-Type': 'application/json'
    }
});

/**
 * Busca informações de endereço através do CEP usando a API ViaCEP
 */
export async function lookupCep(cep) {
    // Remove caracteres não numéricos do CEP
    const cleanCep = cep.replace(/\D/g, "");

    // Valida se o CEP tem 8 dígitos
    if (cleanCep.length !== 8) {
        throw new Error("CEP deve conter 8 dígitos");
    }

    try {
        const response = await axiosInstance.get(
            `https://viacep.com.br/ws/${cleanCep}/json/`
        );

        if (response.data.erro) {
            throw new Error("CEP não encontrado");
        }

        return response.data;
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.code === "ECONNABORTED") {
                throw new Error("Timeout na consulta do CEP");
            }
            if (error.response?.status === 404) {
                throw new Error("CEP não encontrado");
            }
            throw new Error("Erro na consulta do CEP");
        }
        throw error;
    }
}

/**
 * Formata CEP para exibição (xxxxx-xxx)
 */
export function formatCep(cep) {
    const cleanCep = cep.replace(/\D/g, "");
    if (cleanCep.length <= 5) {
        return cleanCep;
    }
    return `${cleanCep.slice(0, 5)}-${cleanCep.slice(5, 8)}`;
}

/**
 * Valida se o CEP está no formato correto
 */
export function isValidCep(cep) {
    const cleanCep = cep.replace(/\D/g, "");
    return cleanCep.length === 8;
}
